export enum EEmployeeRoles {
  MANAGER = 'MANAGER',
  SUPPLIER = 'SUPPLIER',
  ADMIN = 'ADMIN',
}
